import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PainelType } from '../settings/interfaces/painel';
import { PainelLocalType } from '../settings/interfaces/painelLocal';
import { ServerUrlService } from './server-url.service';

@Injectable({
    providedIn: 'root'
})
export class PainelService {
    private headers: any
    public lastInserted: number | undefined
    constructor(private httpClient: HttpClient, private serverUrl: ServerUrlService) {
        this.headers = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
    }

    getPaineis(): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/paineis`,
            this.headers
        )
    }

    getPainelLocais(id: number | string): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/paineis-local/${id}`,
            this.headers
        )
    }

    updatePainelLocal(formData: PainelLocalType) {
        this.httpClient.put(
            `${this.serverUrl.getUrl()}/paineis-local`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
            }
        )
    }

    deletePainelLocal(id: number) {
        this.httpClient.delete(
            `${this.serverUrl.getUrl()}/paineis-local/${id}`,
            this.headers
        ).subscribe(
            (resp: any) => {
            }
        )
    }

    getEmpresas(): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/paineis-empresa/`,
            this.headers
        )
    }

    getAgendas(): Observable<any> {
        return this.httpClient.get(`${this.serverUrl.getUrl()}/paineis-agenda/`,
            this.headers
        )
    }

    insertPainel(formData: PainelType) {
        this.httpClient.post(
            `${this.serverUrl.getUrl()}/paineis`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
                this.lastInserted = resp.rows[0].id
            }
        )
    }

    insertPainelLocal(formData: PainelLocalType) {
        this.httpClient.post(
            `${this.serverUrl.getUrl()}/paineis-local`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            () => {

            }
        )
    }

    updatePainel(formData: PainelType) {
        this.httpClient.put(
            `${this.serverUrl.getUrl()}/paineis`,
            JSON.stringify(formData),
            this.headers
        ).subscribe(
            (resp: any) => {
                this.lastInserted = resp.rows[0].id
            }
        )
    }

    deletePainel(id: number): void {
        this.httpClient.delete(
            `${this.serverUrl.getUrl()}/paineis/${id}`, this.headers
        ).subscribe(
            (result) => {
            }
        )
    }

    getServiceQueue(agendaMap: { [key: string]: number[] }): Observable<any> {
        const queryParams = Object.entries(agendaMap)
          .map(([key, ids]) => `${key}=${ids.join(',')}`)
          .join('&')
      
        return this.httpClient.get(`${this.serverUrl.getUrl()}/service-queue?${queryParams}`, this.headers)
    }

    updateCarouselSortType(carouselSortByAppointment: any[], carouselSortByCheckin: any[]): Observable<any> {
        return this.httpClient.put(
          `${this.serverUrl.getUrl()}/schedules/carousel-sort-type`,
          JSON.stringify({carouselSortByAppointment, carouselSortByCheckin}),
          this.headers
        )
    }      
}
